module.exports = __webpack_public_path__ + "static/designcode-featured-04c2cabf76588e9529906f5463b1f909.png";